import { siArchiveConstants } from '../../_constants';
import { siArchiveServices } from '../../_services';
import { alertActions } from '../index';

export const siArchiveActions = {
    resetSiArchive,

    getPostedWaybillPerYear,
    getPostedWaybillPerMonth,
    getPostedWaybillPerVessel,
    getPostedWaybillPerVoyage,
    getPostedWaybills,
}

function resetSiArchive() { return { type: siArchiveConstants.RESET } }

function siArchiveFetching() { return { type: siArchiveConstants.SI_ARCHIVE_FETCHING } }
function siArchiveFetched() { return { type: siArchiveConstants.SI_ARCHIVE_FETCHED } }

function getPostedWaybillPerYear() {
    return dispatch => {
        dispatch(siArchiveFetching());
        siArchiveServices.getPostedWaybillPerYear()
            .then(
                PostedWBPerYear => {
                    dispatch(siArchiveFetched());
                    dispatch(success(PostedWBPerYear));
                },
                error => {
                    dispatch(siArchiveFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(PostedWBPerYear) { return { type: siArchiveConstants.GET_POSTED_WB_PER_YEAR, PostedWBPerYear } }
}

function getPostedWaybillPerMonth(year) {
    return dispatch => {
        dispatch(siArchiveFetching());
        siArchiveServices.getPostedWaybillPerMonth(year)
            .then(
                PostedWBPerMonth => {
                    dispatch(siArchiveFetched());
                    dispatch(success(PostedWBPerMonth));
                },
                error => {
                    dispatch(siArchiveFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(PostedWBPerMonth) { return { type: siArchiveConstants.GET_POSTED_WB_PER_MONTH, PostedWBPerMonth } }
}

function getPostedWaybillPerVessel(month) {
    return dispatch => {
        dispatch(siArchiveFetching());
        siArchiveServices.getPostedWaybillPerVessel(month)
            .then(
                PostedWBPerVessel => {
                    dispatch(siArchiveFetched());
                    dispatch(success(PostedWBPerVessel));
                },
                error => {
                    dispatch(siArchiveFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(PostedWBPerVessel) { return { type: siArchiveConstants.GET_POSTED_WB_PER_VESSEL, PostedWBPerVessel } }
}

function getPostedWaybillPerVoyage(vessel, year, month, search) {
    return dispatch => {
        dispatch(siArchiveFetching());
        siArchiveServices.getPostedWaybillPerVoyage(vessel, year, month,  search)
            .then(
                PostedWBPerVoyage => {
                    dispatch(siArchiveFetched());
                    dispatch(success(PostedWBPerVoyage));
                },
                error => {
                    dispatch(siArchiveFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(PostedWBPerVoyage) { return { type: siArchiveConstants.GET_POSTED_WB_PER_VOYAGE, PostedWBPerVoyage } }
}

function getPostedWaybills(voyage) {
    return dispatch => {
        dispatch(siArchiveFetching());
        siArchiveServices.getPostedWaybills(voyage)
            .then(
                PostedWaybill => {
                    dispatch(siArchiveFetched());
                    dispatch(success(PostedWaybill));
                },
                error => {
                    dispatch(siArchiveFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(PostedWaybill) { return { type: siArchiveConstants.GET_POSTED_WAYBILL, PostedWaybill } }
}
